import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "./api";

const KEY = "lo_visitor_id";

function getVisitorId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto?.randomUUID?.() || `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);
    localStorage.setItem(KEY, id);
  }
  return id;
}

const sendBeat = (path) => {
  if (path.startsWith("/admin")) return; // ne pas compter l'espace admin
  api.post("/analytics/track", { visitor_id: getVisitorId(), path }).catch(() => {});
};

// Envoie un heartbeat au montage, à chaque changement de page, puis toutes les 25s.
export function AnalyticsTracker() {
  const loc = useLocation();
  const pathRef = useRef(loc.pathname);

  useEffect(() => {
    pathRef.current = loc.pathname;
    sendBeat(loc.pathname);
  }, [loc.pathname]);

  useEffect(() => {
    const interval = setInterval(() => sendBeat(pathRef.current), 25000);
    const onVisible = () => { if (document.visibilityState === "visible") sendBeat(pathRef.current); };
    document.addEventListener("visibilitychange", onVisible);
    return () => { clearInterval(interval); document.removeEventListener("visibilitychange", onVisible); };
  }, []);

  return null;
}
